<template>
  <LcCard v-bind="{ bodyClass }" header-class="flex items-center justify-between">
    <template #header>
      <h2 class="paragraph-bold">{{ headline }}</h2>
      <LcSwitch v-model:value="isRandom" />
    </template>

    <template v-if="!isRandom" #default>
      <slot />
    </template>
  </LcCard>
</template>

<script lang="ts" setup>
import type { LcCardProps } from '@lottocom/frontend-components'

type Props = Pick<LcCardProps, 'bodyClass'> & {
  headline: string
}

defineProps<Props>()

const isRandom = defineModel('random', { default: true, type: Boolean })
</script>
